/**
 * UI dùng chung cho filter bar Matching P-S.
 *
 * `matchingRangeDateFieldSx` — size + format chuẩn cho MỌI cặp Date From-to
 * trong module Matching P-S. Responsive 2026-05-28: xs flex grow (chia
 * không gian theo toolbar width) + !important fontSize (override iOS zoom
 * fix global ở theme — chấp nhận iOS Safari auto-zoom nhẹ khi user tap, đổi
 * lại filter compact đúng kích thước mobile thay vì 16px to). sm+ giữ
 * width 152 cũ + font compact.
 *
 * `matchingFilterAutocompleteSx` — pattern tương tự cho Autocomplete dùng
 * trong toolbar filter (Grade, Factory…). Áp vào renderInput TextField sx.
 *
 * `matchingFilterLabelSx` — sx áp vào `InputLabelProps.sx` để label responsive
 * theo cùng breakpoint (xs nhỏ hơn).
 */
import type { SxProps, Theme } from '@mui/material/styles'

export const matchingRangeDateFieldSx: SxProps<Theme> = {
  width: { xs: 'auto', sm: 152 },
  flex: { xs: '1 1 110px', sm: 'none' },
  minWidth: { xs: 108, sm: 152 },
  '& .MuiInputBase-root': {
    minHeight: { xs: 26, sm: 26 },
    fontSize: { xs: '0.7rem', sm: '0.72rem' },
  },
  '& .MuiInputBase-input': {
    py: { xs: 0.15, sm: 0.25 },
    px: { xs: 0.5, sm: 0.75 },
    // !important override theme CssBaseline global rule (16px @media xs)
    // → chấp nhận iOS Safari auto-zoom nhẹ khi tap, đổi lại visual compact.
    fontSize: { xs: '0.7rem !important', sm: '0.72rem !important' },
  },
  '& .MuiInputLabel-root': { fontSize: { xs: '0.68rem', sm: '0.78rem' } },
}

export const matchingFilterAutocompleteSx: SxProps<Theme> = {
  '& .MuiInputBase-root': {
    minHeight: { xs: 26, sm: 30 },
    py: { xs: 0, sm: 0.25 },
  },
  '& .MuiInputBase-input': {
    py: { xs: 0.15, sm: 0.35 },
    // !important để override iOS zoom fix global (16px @media xs).
    fontSize: { xs: '0.68rem !important', sm: '0.7rem !important' },
  },
  '& .MuiInputLabel-root': { fontSize: { xs: '0.68rem', sm: '0.78rem' } },
}

/** Stack wrap cho filter toolbar — compact spacing + wrap xs. */
export const matchingFilterStackSx: SxProps<Theme> = {
  px: { xs: 0.25, sm: 0.5 },
  py: { xs: 0.25, sm: 0.3 },
}
